<template>
  <button
    class="btn"
    :class="btnClass"
    v-on="$listeners">
    <span
      class="profile-icon material-icons l-blue">
      edit_document
    </span>
    <span class="profile-button-text">マイデータ</span>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    xl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    btnClass() {
      const arrayClass = ['profile-button']
      if (this.xl) arrayClass.push('profile-button--xl')
      if (this.active) arrayClass.push('profile-button--active')
      return arrayClass
    },
    btnImgStyle() {
      if (this.xl) return {width: '50%'}
      return {width: '50%'}
    }
  },
}
</script>

<style scoped lang="scss">
.profile-button{
  position: relative;
  background-color: $white;
  box-shadow: 1px 2px 6px $grey05;
  border-radius: 50%;
  border: none;
  width: 60px;
  height: 60px;

  .profile-icon {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 15%;
    filter: invert(51%) sepia(51%) saturate(5133%) hue-rotate(176deg) brightness(90%) contrast(105%);
    font-size: 37.5px;
  }

  .profile-button-text {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 23%;
    font-size: 8px;
    font-feature-settings: "palt";
    color: $l-blue;
  }

  &--active{
    .profile-icon {
      filter: invert(17%) sepia(39%) saturate(5752%) hue-rotate(207deg) brightness(70%) contrast(94%);
    }

    .profile-button-text {
      color: $blue;
    }
  }

  &:active {
    background-color: $blue;
  }
}

.profile-button--xl {
  width: 80px;
  height: 80px;
}
</style>